import { controls, grouped } from "../controls";
const upload_trial_balances = {
  label: "Upload Trial Balances",
  pageLabel: "Upload Trial Balances", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  bulk: { columns: ["branch_code", "gl_code", "amount"] },
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Bulk", uid: "bulk" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "branch_code", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Gl Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "gl_code", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Amount" }),
    ...controls.floatOnly({ tab: "filter", placeHolder: "", name: "amount", maxlength: 21 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "branch_code", isRequired: false, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "gl_code", isRequired: false, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Amount" }),
    ...controls.floatOnly({ tab: "general", placeHolder: "", name: "amount", maxlength: 18 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Upload Trial Balances",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Branch Code", accessor: "branch_code", },
      { Header: "Gl Code", accessor: "gl_code", },
      { Header: "Amount", accessor: "amount", },
    ]
  }
};
export default upload_trial_balances;